import React, { useState } from "react";
import { useData } from "../../../context/DataContext";
import { confirmDelete, successToast } from "../../../utils/dialog";

export default function AdminFaqs() {
  const { faqs, addFaq, updateFaq, deleteFaq } = useData();

  const [newFaq, setNewFaq] = useState({
    question: "",
    answer: "",
  });

  const [editingFaq, setEditingFaq] = useState(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewFaq((prev) => ({ ...prev, [name]: value }));
  };

  const handleAddFaq = async () => {
    if (newFaq.question && newFaq.answer) {
      await addFaq(newFaq); // Add the FAQ
      setNewFaq({ question: "", answer: "" });
    }
  };

  const handleUpdateFaq = async () => {
    if (editingFaq && newFaq.question && newFaq.answer) {
      await updateFaq(editingFaq.id, newFaq); // Update the FAQ
      setEditingFaq(null);
      setNewFaq({ question: "", answer: "" });
    }
  };

  const handleEdit = (faq) => {
    setEditingFaq(faq);
    setNewFaq({ question: faq.question, answer: faq.answer });
  };

  const handleDelete = async (id) => {
    if (
      await confirmDelete({
        title: "Delete FAQ?",
        text: "This FAQ will be permanently deleted.",
      })
    ) {
      await deleteFaq(id); // Delete the FAQ
      successToast("FAQ deleted successfully.");
    }
  };

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-4">Manage FAQs</h2>

      {/* Add/Edit Form */}
      <div className="mb-6">
        <h3 className="text-xl font-semibold mb-2">
          {editingFaq ? "Edit FAQ" : "Add New FAQ"}
        </h3>
        <input
          type="text"
          name="question"
          placeholder="Question"
          value={newFaq.question}
          onChange={handleInputChange}
          className="block w-full mb-2 p-2 border rounded"
        />
        <textarea
          name="answer"
          placeholder="Answer"
          value={newFaq.answer}
          onChange={handleInputChange}
          className="block w-full mb-2 p-2 border rounded"
        />
        <button
          onClick={editingFaq ? handleUpdateFaq : handleAddFaq}
          className="px-4 py-2 bg-blue-500 text-white rounded"
        >
          {editingFaq ? "Update FAQ" : "Add FAQ"}
        </button>
        {editingFaq && (
          <button
            onClick={() => {
              setEditingFaq(null);
              setNewFaq({ question: "", answer: "" });
            }}
            className="ml-2 px-4 py-2 bg-gray-500 text-white rounded"
          >
            Cancel
          </button>
        )}
      </div>

      {/* FAQs List */}
      <div>
        <h3 className="text-xl font-semibold mb-2">FAQs</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {faqs.map((faq) => (
            <div key={faq.id} className="p-4 border rounded shadow">
              <h4 className="text-lg font-bold">{faq.question}</h4>
              <p className="text-sm text-gray-600">{faq.answer}</p>
              <div className="mt-2 flex justify-between">
                <button
                  onClick={() => handleEdit(faq)}
                  className="px-3 py-1 bg-yellow-500 text-white rounded"
                >
                  Edit
                </button>
                <button
                  onClick={() => handleDelete(faq.id)}
                  className="px-3 py-1 bg-red-500 text-white rounded"
                >
                  Delete
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}